#import "../fragments/visitor-iq-filter-settings-fragment.graphql"

mutation UpdateVisitorIqFilterSettings($input: VisitorIqFilterSettingsUpdateInput!) {
    visitorIqFilterSettingsUpdate(input: $input) {
        ...VisitorIqFilterSettingsFragment
    }
}
